'use client'

import { createContext } from 'react'

import type { OrderFormCollapsibleConfig } from '@/state/order'

export interface OrderFormCollapsibleContextValue {
  config: Required<OrderFormCollapsibleConfig>
  updateConfig: (patch: Partial<OrderFormCollapsibleConfig>) => void
}

// Default null: components consuming this context must fall back to calling
// useOrderFormCollapsibleConfig(cardId) themselves when no provider is present
// (e.g. the on-grid OrderContainer widget path, which has no expand panel and no
// provider). See CollapsibleAreaInOrderForm for the fallback logic.
export const OrderFormCollapsibleContext = createContext<OrderFormCollapsibleContextValue | null>(
  null
)
